import { z } from 'zod';

export interface Sprint {
  id: number;
  businessID: number;
  name: string;
  startTime: number;
  endTime: number;
  budget: number;
  createdTime: number;
  updatedTime: number;
  createdByID?: number;
  updatedByID?: number;
}

export const SprintDTO = z.object({
  id: z.number().optional(),
  businessID: z.number().optional(),
  name: z.string(),
  startTime: z.number(),
  endTime: z.number(),
  budget: z.number(),
});

export type SprintDTO = z.TypeOf<typeof SprintDTO>;
